export default __webpack_public_path__ + "static/media/headerlogo.62342f31.svg";